import styled from '@emotion/styled';
import { DeckMenuWrapper } from '@seedlang/hoc';
import { PencilIcon, InfoIcon, ListWithBulletIcon, RefreshIcon, SettingsOutlineIcon, ShortcutIcon, ThreeDotsIcon, WarningTriangleIcon } from '@seedlang/icons';
import { AppUI, DeckUI, OverlayUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import DeckMenuItem from 'components/deck/deck_menu_item';
import Dropdown from 'components/dropdown';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import Link from 'components/link';

const Wrapper = styled.div`
  .dropdown-wrapper {
    width: 170px;
    right: 0;
  }
  .left-arrow-icon {
    height: 21px;
  }
  .fa-angle-left {
    font-size: 22px;
    margin-left: -2px;
  }
  .fa-angle-right {
    font-size: 22px;
    margin-left: 2px;
  }
  .info-icon {
    svg {
      width: 2.5px;
    }
  }
  .close-icon {
    svg {
      width: 15px;
    }
  }
  .warning-triangle-icon {
    svg {
      fill: #333;
      width: 15px;
      margin-top: -2px;
    }
  }
  .settings-outline-icon {
    svg {
      width: 17px;
    }
  }
  .question-icon {
    svg {
      width: 9px;
    }
  }
  .refresh-icon {
    svg {
      width: 13px;
    }
  }
  .fa-flag {
    font-size: 12px;
  }
  .shortcut-icon {
    svg {
      width: 13px;
    }
  }
  .list-with-bullet-icon {
    svg {
      width: 13px;
    }
  }
  .pencil-icon {
    svg {
      width: 13px;
      margin: 0;
    }
  }
`;

const MenuIconWrapper = styled.div`
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  .dropdown-icon {
    opacity: 0.4;
    display: flex;
    svg {
      margin-top: 1px;
      width: 7px;
    }
    circle, path {
      fill: #FFF;
    }
  }
`;

@observer
class DeckMenu extends React.Component {
  @computed get translationEditLink() {
    if (isPresent(DeckUI.currentSentence)) {
      return { name: 'builder.sentences.edit', params: { sentenceId: DeckUI.currentSentence.id } };
    } else if (isPresent(DeckUI.currentWord)) {
      return { name: 'builder.words.edit', params: { wordId: DeckUI.currentWord.id } };
    } else return null;
  }

  @computed get showReportMeaningsScreen() {
    return DeckUI.deck?.synonymDeck ||
      (AppUI.user?.showMeanings &&
      AppUI.user?.showVocabMeanings === true &&
      isPresent(DeckUI.currentWord?.meanings));
  }

  onReportTranslation = () => {
    this.props.onReportTranslation();
    if (this.showReportMeaningsScreen) {
      OverlayUI.addOverlay('reportMeanings', {
        open: true,
        word: DeckUI.currentWord,
        synonymAssociation: this.props.synonymAssociation,
        onClose: () => {
          OverlayUI.removeOverlay('reportMeanings');
        },
        onSubmitSuccess: () => {
          DeckUI.createEvent('vocab - report meanings submitted', {
            word_id: DeckUI.currentWord?.id,
          });
        },
      });
      return;
    }
    OverlayUI.addOverlay('sourceEdit');
  }

  render() {
    return (
      <Wrapper>
        <Dropdown
          top={DeckUI.layout.deckHeaderHeight}
          showOnClick
          closeOnDropdownClick
          onShow={this.props.onOpenMenu}
        >
          <MenuIconWrapper>
            <ThreeDotsIcon
              className='dropdown-icon'
            />
          </MenuIconWrapper>
          <div>
            {
              (!DeckUI.deck.triviaDeck || DeckUI.user.admin) &&
              <DeckMenuItem
                onClick={this.props.onRestartCard}
                disabled={this.props.disableResetCard}
              >
                <RefreshIcon />
                Restart Card
              </DeckMenuItem>
            }
            {
              !DeckUI.deck.triviaDeck &&
              <DeckMenuItem
                onClick={this.props.onPreviousCard}
                disabled={DeckUI.userDeck.currentUserCardIsFirstInDeck}
              >
                <div className='icon-wrapper'>
                  <i className='fa fa-angle-left' />
                </div>
                Previous Card
              </DeckMenuItem>
            }
            {
              (DeckUI.user.admin || AppUI.isDevelopment) &&
              <DeckMenuItem
                onClick={this.props.onNextCard}
                disabled={DeckUI.isLastCard}
              >
                <div className='icon-wrapper'>
                  <i className='fa fa-angle-right' />
                </div>
                Next Card
              </DeckMenuItem>
            }
            {
              DeckUI.user.admin &&
              <DeckMenuItem
                onClick={this.props.onGoToCard}
              >
                <ListWithBulletIcon />
                Go to Card
              </DeckMenuItem>
            }
            {
              DeckUI.showDeckGrammar &&
              <DeckMenuItem
                onClick={this.props.onDeckGrammar}
              >
                <InfoIcon />
                Deck Grammar
              </DeckMenuItem>
            }
            {
              (!DeckUI.deck.triviaDeck || DeckUI.user.admin) &&
              <DeckMenuItem
                onClick={this.props.onRestartDeck}
              >
                <RefreshIcon />
                Restart Deck
              </DeckMenuItem>
            }
            <DeckMenuItem
              onClick={this.props.onShortcuts}
            >
              <ShortcutIcon />
              Shortcuts
            </DeckMenuItem>
            <DeckMenuItem
              onClick={this.props.onSettings}
            >
              <SettingsOutlineIcon />
              Settings
            </DeckMenuItem>
            <DeckMenuItem
              onClick={this.props.onReportBug}
            >
              <WarningTriangleIcon />
              Report Bug
            </DeckMenuItem>
            <DeckMenuItem
              onClick={this.onReportTranslation}
              disabled={this.props.disableReport}
            >
              <div className='icon-wrapper'>
                <i className='fa fa-flag' />
              </div>
              {this.props.reportMenuTitle}
            </DeckMenuItem>
            {
              DeckUI.user.admin && isPresent(this.translationEditLink) &&
              <DeckMenuItem>
                <Link
                  to={this.translationEditLink}
                  target='_blank'
                >
                  <PencilIcon />
                  {`Edit ${DeckUI.currentSentence ? 'Sentence' : 'Word'}`}
                </Link>
              </DeckMenuItem>
            }
          </div>
        </Dropdown>
      </Wrapper>
    );
  }
}

export default DeckMenuWrapper(DeckMenu);
